@let positionDataValue = positionData();

<div class="header-container">
  <div class="header-info">
    <div class="icon-container">
      <rt-icon name="positions" size="medium" colorToken="colorIconPrimaryDefault" />
    </div>
    <div class="header-text">
      <span class="position-label">{{
        'tlc.positions.position_details_dialog.header' | translate
      }}</span>
      <span class="position-name">{{ positionDataValue?.name }}</span>
    </div>
    @if (canManageStructure()) {
      <rt-icon-button
        #moreActionsDropdownTrigger="rtOverlayOrigin"
        rt-overlay-origin
        variant="outline"
        shape="square"
        size="medium"
        iconName="more-horiz"
        [pressed]="moreActionsDropdown.open"
        (click)="toggleMoreActionsDropdown(moreActionsDropdown)"
      />
      <ng-template
        #moreActionsDropdown="rtConnectedOverlay"
        [origin]="moreActionsDropdownTrigger"
        (backdropClick)="toggleMoreActionsDropdown(moreActionsDropdown)"
        rt-connected-overlay
        hasBackdrop
      >
        <rt-dropdown [width]="DropdownWidth.SmallX">
          <rt-dropdown-item
            (click)="toggleMoreActionsDropdown(moreActionsDropdown); renamePosition()"
          >
            <rt-icon prefix name="edit" />
            <span>{{ 'tlc.common.rename' | translate }}</span>
          </rt-dropdown-item>
          <rt-dropdown-item
            (click)="toggleMoreActionsDropdown(moreActionsDropdown); deletePosition()"
          >
            <rt-icon prefix name="delete" />
            <span>{{ 'tlc.common.delete' | translate }}</span>
          </rt-dropdown-item>
        </rt-dropdown>
      </ng-template>
    }
  </div>
  <rt-tabs class="tabs-container">
    <rt-tab
      [class.active]="activeTab() === PositionDetailsTab.Employees"
      (click)="setActiveTab(PositionDetailsTab.Employees)"
      >{{ 'tlc.positions.position_details_dialog.tabs.employees.label' | translate }}</rt-tab
    >
    <rt-tab
      [class.active]="activeTab() === PositionDetailsTab.Description"
      (click)="setActiveTab(PositionDetailsTab.Description)"
      >{{ 'tlc.positions.position_details_dialog.tabs.description.label' | translate }}</rt-tab
    >
    <rt-tab
      [class.active]="activeTab() === PositionDetailsTab.Skills"
      (click)="setActiveTab(PositionDetailsTab.Skills)"
      >{{ 'tlc.positions.position_details_dialog.tabs.skills.label' | translate }}</rt-tab
    >
  </rt-tabs>
</div>
<rt-dialog-body variant="white">
  <ng-container
    [rtComponentOutlet]="componentMap.get(activeTab()) ?? null"
    [rtComponentOutletInputs]="{ positionData: positionData() }"
  />
</rt-dialog-body>
